import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import ArrowLeft from '@wix/da-ds/pkg/Icons/ArrowLeft';
import { getBasicBiDataForDuperItem } from '../redux/helpers';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import { BiData } from '@wix/da-bi/pkg/events';
import s from './BackToStreamButton.scss';
const BackToStreamButton = ({ className, exitDuperbrowse, parent, currentItem })=>{
    const { t } = useTranslation();
    const doExit = useCallback(()=>{
        yieldToMain(()=>{
            exitDuperbrowse();
        });
    }, [
        exitDuperbrowse
    ]);
    if (!parent || !currentItem) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(TextButton, {
        icon: ArrowLeft,
        variant: "main",
        size: "small",
        biData: BiData(_object_spread_props(_object_spread({
            evid: 304
        }, getBasicBiDataForDuperItem(currentItem)), {
            link_url: parent.url,
            next_itemid: parent.itemId,
            next_typeid: parent.typeId
        })),
        className: classnames(s['duperexit'], className),
        onClick: doExit,
        noHorizontalPaddings: false
    }, parent.title || t('deviation.duperbrowse.back'));
};
BackToStreamButton.displayName = 'BackToStreamButton';
export default BackToStreamButton;

//# sourceMappingURL=BackToStreamButton.js.map